import React, { Component } from "react";
import Header from "../navigation/header/Header";
import Footer from "./Footer";
import HeaderMin from "../navigation/header/HeaderMin";
import FooterMin from "./FooterMin";
import ScrollTop from "../shared/ScrollTop";
import { connect } from "react-redux";
import { isGDPRSet } from "../../services/PersonConsent";
import { Paths } from "../../constants/UrlConstants";
import { Redirect } from "react-router-dom";
import { setPolicyDetails,setContactPreferences,setCommunicationPreferences } from "../../actions/policy/policyActions";
import PolicyRequired from "../../components/shared/PolicyRequired";
import { Layouts } from "../../constants/Constants";
import loadingStyles from "../../assets/css/modules/shared/loading.css";
import GoogleTagManagerDataLayer from "../../analytics/google/GoogleTagManagerDataLayer";
import TimeoutRedirect from "../../components/shared/TimeoutRedirect";
import BackgroundInternalView from "../../assets/img/internal-view-bg.png";
import layoutStyle from "../../assets/css/modules/shared/layout.css";
import UserInteraction from "./UserInteraction";
import loader from "../../assets/img/axaLoader.gif";
import holLoader from "../../assets/img/hol/holLoader.gif";
import Manifest from "./Manifest";
import VersionIncompatible from "../../components/shared/VersionIncompatible";
import { updateNavigationMenu } from "../navigation/actions/navigationMenuActions";
import SiteRedirect from "../navigation/SiteRedirect";
import { RebrandHelper } from "../../helpers/brand/RebrandHelper";
import CookieBar from "../banners/CookieBar";

var internalViewBackgroundStyle = {
  "background-repeat": "repeat",
  "background-size": "190px",
  backgroundImage: `url(${BackgroundInternalView})`
};

export const mapStateToLayout = (state , preferenceReducer = {},onboardingReducer = {} ) => {
  const isInternalView =
    state.policyReducer &&
    state.policyReducer.policyDetails &&
    state.policyReducer.policyDetails.IsInternalView;
  const isUserOnboarding = state.onboardingReducer && state.onboardingReducer.isUserOnboarding;
  const contactPreferencenceInternalView =
    state.layoutReducer && state.layoutReducer.contactPreferencenceInternalView;
  const communicationValue =state.preferenceReducer && state.preferenceReducer.communicationValue;
  const personnotfound= state.preferenceReducer && state.preferenceReducer.personnotfound;
  const contactValue = state.preferenceReducer && state.preferenceReducer.contactValue; 
  const contactPreferencekeys = state.preferenceReducer && state.preferenceReducer.contactPreferencekeys;
  const communicationPreferenceKeys = state.preferenceReducer && state.preferenceReducer.communicationPreferencekeys;
  const isElgibleCustomised = state.preferenceReducer && state.preferenceReducer.isElgibleCustomised;
  return {
    isUserOnboarding,
    communicationValue,    
    contactValue ,
    contactPreferencekeys, 
    communicationPreferenceKeys,
    personnotfound,
    isElgibleCustomised,
    isLoggedIn: state.accountReducer && state.accountReducer.isLoggedIn,
    PersonConsent:
      state.policyReducer &&
      state.policyReducer.selectedPolicy &&
      state.policyReducer.selectedPolicy.PersonConsent,
    layout: state.layoutReducer && state.layoutReducer.layout,
    inProgress:
      state.networkStateReducer && state.networkStateReducer.inProgress,
    isInternalView,
    contactPreferencenceInternalView,
    inProgressForComponent:
      state.networkStateReducer &&
      state.networkStateReducer.inProgressForComponent
  };
};

const getSiteBrandTitle = (layout, title = "") => {
  let fullTitle = "";

  if (title) {
    fullTitle = `- ${title}`;
  }

  if (layout && layout === "HOL") {
    return `Customer Online ${fullTitle} | Health-on-Line`;
  } else {
    return `Member Online ${fullTitle} | ${RebrandHelper.getAxaBrandName()}`;
  }
};

function RedirectToPersonConsent (props)   {      
  if (!props.contactPreferencenceInternalView &&
    (props.contactValue === null || props.contactValue === undefined) &&
     (props.contactPreferencekeys !==undefined || props.contactPreferencekeys !==null) &&
     props.isLoggedIn &&
     !props.GDPRNotRequired && !isGDPRSet(props.PersonConsent)      
     && props.isUserOnboarding
  ) {
    if(props.isElgibleCustomised === "true" && props.personnotfound !== false){        
        return <Redirect to={Paths.HomeContactPreference} />;
    }
    else{
      return props.children;
    }
  } 
  else if (!props.contactPreferencenceInternalView &&       
    (props.communicationValue === null || props.communicationValue === undefined) &&
    props.communicationPreferenceKeys !=null &&
    props.isLoggedIn &&
    !props.GDPRNotRequired && !isGDPRSet(props.PersonConsent)
    && props.isUserOnboarding
  ) {
    if(props.isElgibleCustomised === "true" && props.personnotfound !== false ){
        return <Redirect to={Paths.HomeCommunicationPreference} />;        
    }
    else{
      return props.children;
    }
  }    
else if (!props.contactPreferencenceInternalView &&
    !isGDPRSet(props.PersonConsent) &&
    !props.GDPRNotRequired &&
    props.isLoggedIn
  ) {
    return <Redirect to={Paths.PersonConsent} />;
  }
  else {      
    return props.children;      
  } 
}

const getLoader = ({ layout }) => {
  if (layout === Layouts.HOL) {
    return holLoader;
  }
  return loader;
};

export class Layout extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.returnHeader = this.returnHeader.bind(this);
    this.returnFooter = this.returnFooter.bind(this);
  }

  componentDidUpdate() {
    const {
      browserTitle,
      layout,
      updateNavigationMenu,
      selectedMenu
    } = this.props;

    document.title = getSiteBrandTitle(layout, browserTitle);
    updateNavigationMenu({ selectedMenu });
  }

  componentDidMount() {
    document.title = getSiteBrandTitle(
      this.props.layout,
      this.props.browserTitle
    );
  }

  returnHeader(isLoggedIn) {
    return isLoggedIn && !this.props.showHeaderMin ? (
      <Header {...this.props} />
    ) : (
      <HeaderMin
        headerTitle={this.props.pageTitle}
        history={this.props.history}
        showCancelButton={this.props.showCancelButton}
        showLogoutButton={this.props.showLogoutButton}
        cancelButtonText={this.props.cancelButtonText}
      />
    );
  }

  returnFooter(isLoggedIn) {
    return isLoggedIn && !this.props.showFooterMin ? (
      <Footer {...this.props} />
    ) : (
      <FooterMin {...this.props} />
    );
  }

  render() {
    let wrapperStyle = this.props.layout === Layouts.HOL ? "holroot" : "";
    return (
      <ScrollTop>
        {window && window.location && window.location.pathname && (
          <div id="skip">
            <a href={`${window.location.pathname}#mainContent`}>
              Skip to main content
            </a>
          </div>
        )}
        <SiteRedirect />
        <GoogleTagManagerDataLayer
          pageName={getSiteBrandTitle(
            this.props.layout,
            this.props.browserTitle
          )}
          pageProduct={this.props.pageProduct}
          pageType={this.props.pageType}
        />
        <Manifest />
        <UserInteraction />
        <TimeoutRedirect />
        <VersionIncompatible checkVersion={this.props.checkVersion} />

        {this.props.inProgress || this.props.inProgressForComponent ? (
          <div id="loadingModal" className={loadingStyles.loadingModal}>
            <img src={getLoader(this.props)} alt="Loading" />
          </div>
        ) : null}

        <PolicyRequired
          isPolicyDetailsRequired={!this.props.PolicyNotRequired}
          selectedPolicyNotRequired={this.props.selectedPolicyNotRequired}
          history={this.props.history}
          systemAvailabilityCheck={this.props.systemAvailabilityCheck}
        >
          <div className={layoutStyle.rootWrapper + " " + wrapperStyle}>
            {(this.props.isLoggedIn && !(window.axa.isRemoveAXAHealthBannerOffer && this.props.layout !== Layouts.HOL)) ? <CookieBar /> : null}

            {this.returnHeader(this.props.isLoggedIn)}
            <div
              id="mainContent"
              className={layoutStyle.contentWrapper}
              role="main"
              style={
                this.props.isInternalView ? internalViewBackgroundStyle : null
              }
            >
              {RedirectToPersonConsent(this.props)}              
            </div>
            {this.returnFooter(this.props.isLoggedIn)}
          </div>
        </PolicyRequired>
      </ScrollTop>
    );
  }
}
export default connect(mapStateToLayout, {
  setPolicyDetails,
  setCommunicationPreferences,
  setContactPreferences,
  updateNavigationMenu
})(Layout);
